import {useMemo} from 'react'

import {
  MonaFooter as WebGLMonaFooter,
  type MonaFooterProps as WebGLMonaFooterProps,
} from '../../../../../brand/components/MonaFooter/MonaFooter'

import Styles from './MonaFooter.module.css'

export interface FeaturedRepository {
  nameWithOwner: string
  description: string | null
  url: string
  newStars: number
}

export interface MonaFooterProps {
  mona: WebGLMonaFooterProps['mona']
  repos: WebGLMonaFooterProps['repos'] & {
    a11y: {
      title: string
    }
  }
}

export const defaultProps: Partial<MonaFooterProps> = {}

export const MonaFooter = (props: MonaFooterProps) => {
  const initializedProps: MonaFooterProps = {...defaultProps, ...props}
  const {mona, repos} = initializedProps
  const artworkProps = useMemo(
    () => ({
      mona: {...mona},
      repos: {items: repos.items, starsTemplate: repos.starsTemplate.replaceAll('{newStars}', '{count}')},
    }),
    [mona, repos],
  )

  return (
    <div className={Styles['MonaFooter']}>
      <h2 className="visually-hidden">{repos.a11y.title}</h2>
      <WebGLMonaFooter {...artworkProps} />
    </div>
  )
}
